module.exports = __webpack_public_path__ + "static/media/pakistani.ba117cee.png";